var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAsset2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 198.47 200.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#3d57a7;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M105.35.85c-73.68-12.13-140,109.22-85.09,105.56,120.43-8-50.1,78,71.94,93.4,54.63,6.9,102.42-38,106.05-92.9S159.68,9.8,105.35.85ZM168.17,55.3A13.41,13.41,0,1,1,154,67.92,13.4,13.4,0,0,1,168.17,55.3ZM55.42,52.1A13.41,13.41,0,1,1,42.8,38,13.41,13.41,0,0,1,55.42,52.1Zm1.29-22.44A13.41,13.41,0,1,1,69.33,43.82,13.41,13.41,0,0,1,56.71,29.66ZM99.3,163.72c-10.24,15.07-25.4,22.63-33.85,16.89s-7-22.62,3.26-37.7,25.4-22.63,33.85-16.88S109.55,148.65,99.3,163.72ZM120.1,26a13.41,13.41,0,1,1-12.63-14.16A13.41,13.41,0,0,1,120.1,26Zm8.66,13.57a13.42,13.42,0,1,1,12.63,14.16A13.42,13.42,0,0,1,128.76,39.6Zm27.66,125.78a13.42,13.42,0,1,1-12.63-14.16A13.43,13.43,0,0,1,156.42,165.38Zm23.33-27a13.41,13.41,0,1,1-12.62-14.16A13.4,13.4,0,0,1,179.75,138.39Zm9.87-32.84A13.41,13.41,0,0,1,162.84,104C163.48,92.76,169.6,91,177,91.39A13.41,13.41,0,0,1,189.62,105.55Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset2);
export default __webpack_public_path__ + "static/media/Asset2.e83668ea57f9c0132676c84e9408cb77.svg";
export { ForwardRef as ReactComponent };